import { Button, LogoIconFletch } from '@repo/atomic-components';
import { LoginTemplate } from '@/ui/templates';
import { useNavigate } from 'react-router';

export const LoginPage = () => {
  const navigate = useNavigate();

  const handleClick = () => navigate('/login/redirect', { relative: 'path' });

  return (
    <LoginTemplate>
      <div className="flex w-85 flex-col items-center justify-center">
        <LogoIconFletch width={57} height={54} />
        <p className="text-theme-black mt-4 text-2xl font-normal">
          Sign in to <span className="text-2xl font-semibold">Fletch</span>
        </p>

        <Button
          className="text-theme-black hover:bg-theme-background-grey mt-7 justify-center px-5 font-bold"
          size="small"
          outlined
          onClick={handleClick}
        >
          Log in with Microsoft
        </Button>
      </div>
    </LoginTemplate>
  );
};
